import React from 'react';
import NavBarAttendant from '../components/nav/navbar-attendant.js';
import AuthCheck from '../components/auth-check.js';
import EquipmentPage from '../components/equipment/equipment-page.js';
import MountAtPageTop from '../components/utility/mount-at-page-top.js';
import setTitle from '../decorators/set-title.js';

export class EquipmentRoute extends React.PureComponent {
  render() {
    return (
      <div className="">
        <AuthCheck />
        <MountAtPageTop />
        <NavBarAttendant />
        <div className="variable-width-column">
          <EquipmentPage />
        </div>
      </div>
    );
  }
}

EquipmentRoute = setTitle(() => {
  return 'Equipment';
})(EquipmentRoute);

export default EquipmentRoute;
